import {
  BlockStack,
  Button,
  Icon,
  RadioButton,
  Select,
  Text,
} from "@shopify/polaris";
import { ProductIcon } from "@shopify/polaris-icons";
import { useCallback, useEffect, useState } from "react";
import {
  conditionOptions,
  genderOptions,
  ageOptions,
} from "../../utils/constants";
import axios from "axios";
import { useLocation } from "react-router-dom";

const DefaultSettings = () => {
  const [inputValue, setInputValue] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [category, setCategory] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [productCondition, setProductCondition] = useState("");
  const [productIdentifier, setProductIdentifier] =
    useState("brand_sku_barcode");
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const paramValue = urlParams.get("shop");
  const shop = paramValue;

  // Fetch settings from API when component mounts
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/shopify/store/settings?shop=${shop}`
        );
        if (!response.ok) throw new Error("Failed to fetch settings");

        const data = await response.json();
        if (data.data) {
          const shopifySettings = data.data;
          console.log("Shopify Settings", shopifySettings);
          if (shopifySettings.shopifySettings) {
            const savedSettings = shopifySettings.shopifySettings;

            setCategory(savedSettings?.productCategory || "");
            setAge(savedSettings?.age || "");
            setGender(savedSettings?.gender || "");
            setProductCondition(savedSettings?.productCondition || "");
            setProductIdentifier(
              savedSettings?.productIdentifier || "brand_sku_barcode"
            );
          }
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };

    fetchSettings();
    fetchProductCategories();
  }, [shop]);

  const fetchProductCategories = async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}/api/google/get-product-categories?shop=${paramValue}&search=${inputValue}`;
      const response = await axios.get(apiUrl);
      console.log("fetchProductCategories response", response);
      if (response.status == "200") {
        const productCategories = response.data;
        setProductCategory(productCategories?.categories);
      } else {
        console.log(
          "fetchProductCategories Error fetching product details:",
          response.data
        );
      }
    } catch (error) {
      console.log(
        "fetchProductCategories Error fetching product details:",
        error
      );
    } finally {
      console.log("fetchProductCategories finally");
    }
  };

  const handleProductChange = useCallback(
    (value) => setProductCondition(value),
    []
  );
  const handleGenderChange = useCallback((value) => setGender(value), []);
  const handleAgeChange = useCallback((value) => setAge(value), []);
  const handleProductCategoryChange = (e) => {
    console.log(e);
    setCategory(e);
  };
  const handleIdentifierChange = useCallback(
    (_, newValue) => setProductIdentifier(newValue),
    []
  );

  const saveSettings = async () => {
    const settings = {
      shopifySettings: {
        productCategory: category,
        age,
        gender,
        productCondition,
        productIdentifier,
      },
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/shopify/store/update_settings?shop=${shop}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ settings }),
        }
      );

      const result = await response.json();
      if (response.ok) {
        console.log("Settings saved successfully:", result);
        alert("Settings saved successfully!");
      } else {
        console.error("Error saving settings:", result);
        alert("Failed to save settings!");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while saving settings.");
    }
  };

  return (
    <div className="settings-card">
      <div className="settings-card__header">
        <span className="app-icon-tile app-icon-tile--success">
          <Icon source={ProductIcon} tone="base" />
        </span>
        <div>
          <h3>Default Settings</h3>
          <p>Fallback attributes applied when Shopify data is missing.</p>
        </div>
      </div>

      <BlockStack gap="400">
        <Select
          label="Default Google Product Category"
          options={productCategory}
          onChange={handleProductCategoryChange}
          value={category}
          placeholder="Type to search for your Google Product Category"
        />
        <Select
          label="Default Age Group"
          options={ageOptions}
          onChange={handleAgeChange}
          value={age}
          placeholder="Select an option from dropdown"
        />
        <Select
          label="Default Gender"
          options={genderOptions}
          onChange={handleGenderChange}
          value={gender}
          placeholder="Select an option from dropdown"
        />
        <Select
          label="Default Product Condition"
          options={conditionOptions}
          onChange={handleProductChange}
          value={productCondition}
          placeholder="Select an option from dropdown"
        />
        <div>
          <Text variant="bodyMd" as="p" fontWeight="semibold">
            Default Product Identifier Management
          </Text>
          <BlockStack gap="100">
            <RadioButton
              label="Submit Brand Name, MPN (SKU) and GTIN (Barcode)"
              id="brand_sku_barcode"
              name="productIdentifier"
              checked={productIdentifier === "brand_sku_barcode"}
              onChange={handleIdentifierChange}
            />
            <RadioButton
              label="Submit Brand Name and MPN (SKU)"
              id="brand_sku"
              name="productIdentifier"
              checked={productIdentifier === "brand_sku"}
              onChange={handleIdentifierChange}
            />
            <RadioButton
              label="Submit Product as Custom Product"
              id="custom_product"
              name="productIdentifier"
              checked={productIdentifier === "custom_product"}
              onChange={handleIdentifierChange}
            />
          </BlockStack>
        </div>
      </BlockStack>

      <div className="settings-actions">
        <Button variant="primary" onClick={saveSettings}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default DefaultSettings;
